import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import moment from "moment";
import { useHistory } from "react-router-dom";

const ApprovedPayments = (params) => {
  const dispatch = useDispatch();
  const approvedPaymentsData = useSelector(
    (state) => state?.financeReducer?.approvedPaymentsData
  );
  const history = useHistory();
  useEffect(() => {
    dispatch(actions.getApprovedPaymentsData());
  }, []);

  const [unsubmittedIDS, setUnsubmittedIDS] = useState({
    ids: [],
    isAllSelected: false,
  });

  function handleAll() {
    if (unsubmittedIDS?.isAllSelected)
      setUnsubmittedIDS({
        ids: [],
        isAllSelected: false,
      });
    else {
      setUnsubmittedIDS({
        ids: approvedPaymentsData?.payments?.map((el) => el.id),
        isAllSelected: true,
      });
    }
  }

  function handleSingle(targetId) {
    const targetIdIndex = unsubmittedIDS?.ids?.findIndex(
      (el) => el == targetId
    );
    const checkedIdsLength = unsubmittedIDS?.ids?.length;
    const totalIdsLength = approvedPaymentsData?.payments?.length;
    const copyIds = [...unsubmittedIDS?.ids];

    if (targetIdIndex !== -1) {
      copyIds.splice(targetIdIndex, 1);
      setUnsubmittedIDS({
        ids: copyIds,
        isAllSelected: false,
      });
    } else {
      if (checkedIdsLength === totalIdsLength - 1)
        setUnsubmittedIDS({
          ids: approvedPaymentsData?.payments?.map((el) => el.id),
          isAllSelected: true,
        });
      else {
        setUnsubmittedIDS({
          ids: [...copyIds, targetId],
          isAllSelected: false,
        });
      }
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div class="row mx-0">
                  <div class="shadowclass">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert">
                          {" "}
                          Unsubmitted Payments{" "}
                          <a href="#" class="print-cammond"></a>{" "}
                        </h4>
                        <div class="row justify-content-between">
                          <div class="col-md-12 align-right">
                            <button
                              onClick={() =>
                                dispatch(
                                  actions?.postApprovedPaymentsData({
                                    payment_ids: unsubmittedIDS?.ids,
                                  })
                                )
                              }
                              id="submitBut"
                              type="submit"
                              class="btn green-btn-revert mx-0"
                            >
                              Submit Selected
                            </button>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div className="table-responsive">
                            <table className="checklist-table">
                              <thead>
                                <tr>
                                  <th>
                                    <a class="checkbox avaiCheck">
                                      <input
                                        onClick={() => handleAll()}
                                        type="checkbox"
                                        name="master_check"
                                        class="avail_checkbox"
                                        value=""
                                        id="checkbox_order_id"
                                        checked={unsubmittedIDS?.isAllSelected}
                                      />
                                      <label for="checkbox_order_id"></label>
                                    </a>
                                  </th>
                                  <th> ID </th>
                                  <th className="min-wd-150">Payee</th>
                                  <th>Amount</th>
                                  <th>Tax</th>
                                  <th>Payment Account</th>
                                  <th>Transaction Date</th>
                                  <th>Created</th>
                                  <th> Actions </th>
                                </tr>
                              </thead>
                              <tbody>
                                {approvedPaymentsData?.payments?.map(
                                  (el, idx) => (
                                    <tr>
                                      <td>
                                        <a class="checkbox avaiCheck">
                                          <input
                                            onClick={() => handleSingle(el.id)}
                                            type="checkbox"
                                            name="ids[]"
                                            class="avail_checkbox child_box"
                                            id={"order_id_15558" + idx}
                                            checked={unsubmittedIDS?.ids?.includes(
                                              el.id
                                            )}
                                          />
                                          <label for={"order_id_15558" + idx}>
                                            {" "}
                                          </label>
                                        </a>
                                      </td>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <b>{el?.finance_payee?.payee_name}</b>{" "}
                                        <br />
                                        {el?.finance_payee?.finance_group?.name}
                                      </td>
                                      <td>
                                        {" "}
                                        {approvedPaymentsData?.currency +
                                          " " +
                                          el?.amount}
                                      </td>
                                      <td>
                                        {approvedPaymentsData?.currency +
                                          " " +
                                          el?.tax}
                                      </td>
                                      <td>{el?.payment_account?.name}</td>
                                      <td>{el?.transaction_date}</td>
                                      <td>{el?.created.slice(0, 10)}</td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            dispatch(
                                              actions?.getViewPaymentData({
                                                id: el?.id,
                                              })
                                            );
                                            history.push(
                                              "/finance/payments/view-payment",
                                              {
                                                id: el?.id,
                                              }
                                            );
                                          }}
                                          class="circle_icon"
                                        >
                                          <i class="iconSprites eye-icon"></i>
                                        </a>{" "}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mx-0">
                  <div class="shadowclass">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert">
                          {" "}
                          Scheduled Payment{" "}
                          <a href="#" class="print-cammond"></a>{" "}
                        </h4>
                        <div class="row justify-content-between">
                          <div class="col-md-4">
                            <div class="search-box">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div className="table-responsive">
                            <table className="checklist-table">
                              <thead>
                                <tr>
                                  {/* <th width="60" className="min-checkbox">
                                    {" "}
                                  </th> */}
                                  <th> ID </th>
                                  <th className="min-wd-150">Payee</th>
                                  <th>Amount</th>
                                  <th>Tax</th>
                                  <th>Payment Account</th>
                                  <th>Transaction Date</th>
                                  <th>Created</th>
                                  <th> Actions </th>
                                </tr>
                              </thead>
                              <tbody>
                                {approvedPaymentsData?.scheduled_payments?.map(
                                  (el, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <b>{el?.finance_payee?.payee_name}</b>{" "}
                                        <br />
                                        {el?.finance_payee?.finance_group?.name}
                                      </td>
                                      <td>
                                        {" "}
                                        {approvedPaymentsData?.currency +
                                          " " +
                                          el?.amount}
                                      </td>
                                      <td>
                                        {approvedPaymentsData?.currency +
                                          " " +
                                          el?.tax}
                                      </td>
                                      <td>{el?.payment_account?.name}</td>
                                      <td>{el?.transaction_date}</td>
                                      <td>{el?.created.slice(0, 10)}</td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            dispatch(
                                              actions?.getViewPaymentData({
                                                id: el?.id,
                                              })
                                            );
                                            history.push(
                                              "/finance/payments/view-payment",
                                              {
                                                id: el?.id,
                                              }
                                            );
                                          }}
                                          class="circle_icon"
                                        >
                                          <i class="iconSprites eye-icon"></i>
                                        </a>{" "}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default ApprovedPayments;
